export function updateType(source, destination) {
    Object.keys(source).forEach(a => {
        if (typeof destination[a] !== typeof source[a]) {
            // eslint-disable-next-line default-case
            switch (typeof source[a]) {
                case "number":
                    destination[a] = Number(destination[a]);
                    break;
            }
        }
    });
}